module.exports = __webpack_public_path__ + "static/media/S (11).474d6010.jpg";